import { render, staticRenderFns } from "./SafeMessageContent.vue?vue&type=template&id=4fed3f06"
import script from "./SafeMessageContent.vue?vue&type=script&lang=js"
export * from "./SafeMessageContent.vue?vue&type=script&lang=js"
import style0 from "./SafeMessageContent.vue?vue&type=style&index=0&id=4fed3f06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports